import { FlexSpace, FormModal, InputField } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { responsiveFields } from '@ubeya/shared-web/style';
import useAccountConfig from '@ubeya/shared/hooks/account/useAccountConfig';
import { onlyPositiveNumber } from '@ubeya/shared/utils/form';
import React, { useCallback, useContext, useMemo } from 'react';
import styled from 'styled-components';

const Container = styled(FlexSpace)`
  ${responsiveFields.mobile};
`;

const PositionsGroupWageModal = ({ positionsWages = [], onClose, onConfirm }) => {
  const { t } = useContext(ConfigContext);
  const { currency } = useContext(ConfigContext);
  const { account } = useAccountConfig();

  const isFlatWage = account?.payrollConfig?.flatIsActive;

  const initialValues = useMemo(
    () => ({
      flatHours:
        new Set(positionsWages.map(({ flatHours }) => flatHours)).size === 1 ? positionsWages?.[0]?.flatHours : null,
      hourlyWage:
        new Set(positionsWages.map(({ hourlyWage }) => hourlyWage)).size === 1 ? positionsWages?.[0]?.hourlyWage : null,
      flatWage:
        new Set(positionsWages.map(({ flatWage }) => flatWage)).size === 1 ? positionsWages?.[0]?.flatWage : null
    }),
    [positionsWages]
  );

  const handleSubmit = useCallback(
    (values) => {
      onConfirm({
        flatHours: values.flatHours || 0,
        hourlyWage: values.hourlyWage || 0,
        flatWage: values.flatWage || 0
      });
      onClose();
    },
    [onClose, onConfirm]
  );

  return (
    <FormModal
      initialValues={initialValues}
      onSubmit={handleSubmit}
      size="small"
      onClose={onClose}
      title={t('editPositionsGroupWage')}
      confirmText={t('save')}
      showCancelButton
      isScrollableContent={false}
      disabledOnPristine={false}>
      <Container>
        <InputField
          name="hourlyWage"
          type="number"
          title={`${t('hourlyRate')} (${currency})`}
          onChange={onlyPositiveNumber}
          min={0}
          autoFocus
        />

        {isFlatWage && (
          <>
            <InputField
              name="flatWage"
              title={`${t('flatWage')} (${currency})`}
              onChange={onlyPositiveNumber}
              type="number"
            />
            <InputField name="flatHours" title={t('flatHours')} onChange={onlyPositiveNumber} type="number" />
          </>
        )}
      </Container>
    </FormModal>
  );
};

export default PositionsGroupWageModal;
